// Centralized theme configuration for the application
// Colors inspired by agriculture: green fields and dark earth tones

export const theme = {
  colors: {
    // Primary colors - greens inspired by agriculture
    primary: '#4A7C4E',           // Forest green - main brand color
    primaryDark: '#2F5233',       // Darker green for hover states
    primaryLight: '#6B9B6F',      // Lighter green for backgrounds
    primaryPale: '#E8F5E8',       // Very light green for subtle backgrounds

    // Secondary colors - earth tones
    secondary: '#8B6F47',         // Earth brown - secondary accent
    secondaryDark: '#6B5433',     // Dark earth
    secondaryLight: '#A89075',    // Light earth

    // Action colors - not too bright, sophisticated
    success: '#52A65E',           // Muted success green
    warning: '#D98F3A',           // Darker orange (instead of bright red)
    danger: '#C85A4E',            // Terracotta red (softer than bright red)
    info: '#5B9AA9',              // Calm blue-green

    // Neutral colors - greys
    darkGrey: '#3A3A3A',          // Dark grey for text
    mediumGrey: '#6C757D',        // Medium grey
    lightGrey: '#D4D4D4',         // Light grey for borders
    paleGrey: '#F5F5F5',          // Very light grey for backgrounds

    // Background colors
    background: '#FAFAFA',        // Main background
    backgroundAlt: '#FFFFFF',     // Alternative background (cards, etc)

    // Text colors
    textPrimary: '#2C2C2C',       // Primary text
    textSecondary: '#5A5A5A',     // Secondary text
    textLight: '#858585',         // Light text (hints, etc)
    textWhite: '#FFFFFF',         // White text for dark backgrounds

    // Tool-specific colors (from original design)
    border: '#E63946',            // Red for border tool
    gamefence: '#52A65E',         // Green for gamefence tool
    croparea: '#D4A650',          // Golden for crop area tool
    gpsPoint: '#5B9AA9',          // Blue-green for GPS points
  },

  // Spacing system
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },

  // Border radius
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    round: '50%',
  },

  // Shadows
  shadows: {
    sm: '0 2px 4px rgba(0, 0, 0, 0.1)',
    md: '0 4px 8px rgba(0, 0, 0, 0.15)',
    lg: '0 8px 16px rgba(0, 0, 0, 0.2)',
  },

  // Typography
  typography: {
    fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
    fontSize: {
      xs: '12px',
      sm: '14px',
      md: '16px',
      lg: '18px',
      xl: '24px',
      xxl: '32px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },

  // Ant Design theme token configuration
  antdToken: {
    colorPrimary: '#4A7C4E',
    colorSuccess: '#52A65E',
    colorWarning: '#D98F3A',
    colorError: '#C85A4E',
    colorInfo: '#5B9AA9',
    borderRadius: 8,
    colorBgContainer: '#FFFFFF',
    colorBgLayout: '#FAFAFA',
    fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
  },
};

export default theme;
